<h2>Files</h2>
<p *ngIf="!(dataChange | async)?.length">This customer does not have any files yet.</p>
<div class="example-container mat-elevation-z2"
  [style.display]="(dataChange | async)?.length ? 'block' : 'none'">
  <mat-table #table
    [dataSource]="dataSource">
    <ng-container cdkColumnDef="originalFileName">
      <mat-header-cell *cdkHeaderCellDef>Filename</mat-header-cell>
      <mat-cell *cdkCellDef="let row">{{ row.originalFileName }}
      </mat-cell>
    </ng-container>
    <ng-container cdkColumnDef="lastUpdated">
      <mat-header-cell *cdkHeaderCellDef>Date</mat-header-cell>
      <mat-cell *cdkCellDef="let row"> {{ row.lastUpdated | date }} </mat-cell>
    </ng-container>
    <ng-container cdkColumnDef="id">
      <mat-header-cell *cdkHeaderCellDef>Action</mat-header-cell>
      <mat-cell *cdkCellDef="let row">
        <a mat-button
          color="primary"
          target="_blank"
          [href]="fileLink(row)">Open</a>
        <button mat-button
          color="warn"
          (click)="removeFile.emit(row)">Remove</button>
      </mat-cell>
    </ng-container>
    <mat-header-row *cdkHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *cdkRowDef="let row; columns: displayedColumns;"></mat-row>
  </mat-table>
</div>